interface StatusFilterProps {
  readonly value: string;
  readonly onChange: (status: string) => void;
  readonly options: readonly { value: string; label: string }[];
}

export const StatusFilter = ({ value, onChange, options }: StatusFilterProps) => {
  return (
    <div className="flex" style={{ gap: 'var(--space-1)', flexWrap: 'wrap' }}>
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          onClick={() => onChange(option.value)}
          className="filter-pill"
          style={{
            padding: 'var(--space-2) var(--space-3)',
            fontSize: 'var(--text-sm)',
            fontWeight: value === option.value ? 'var(--font-weight-semibold)' : 'var(--font-weight-normal)',
            color: value === option.value ? 'var(--color-primary-700)' : 'var(--text-secondary)',
            backgroundColor: value === option.value ? 'var(--color-primary-50)' : 'transparent',
            border: '1px solid',
            borderColor: value === option.value ? 'var(--color-primary-200)' : 'var(--border-default)',
            borderRadius: 'var(--radius-full)',
            cursor: 'pointer',
            transition: 'all var(--duration-fast) var(--ease-out)',
            minHeight: '36px',
            display: 'inline-flex',
            alignItems: 'center',
          }}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};
